// Firebase stripped — stubbed exports for compatibility
const noop = () => ({});
const collectionStub = { doc: noop, where: noop, get: noop, onSnapshot: noop, add: noop, set: noop };
const auth = { currentUser: null, onAuthStateChanged: (cb) => cb(null) };
const db = { collection: () => ({ ...collectionStub }) };
const storage = { child: () => ({ put: noop, getDownloadURL: noop }) };
const fieldValue = { serverTimestamp: noop, increment: noop, arrayUnion: noop, arrayRemove: noop };
const google_provider = {};
const email_provider = {};

export { auth, db, storage, fieldValue, google_provider, email_provider };
